import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

type Props = {
    label: string;
    showExplanatoryText: boolean;
};

export function UneditableField(props: Props) {
    return (
        <div className='pt-8'>
            <StackLegacy spacing={8}>
                <Body size='small'>
                    This field maps to the{' '}
                    <Link
                        // @ts-expect-error
                        as={RoutedLink}
                        to={
                            NutClientConfig.hasPerPipelineCustomFields
                                ? `/setup/custom-field`
                                : '/setup/custom-field-old'
                        }
                        newTab={true}
                        variant='primary'
                        size='small'
                    >
                        {props.label}
                    </Link>{' '}
                    field in Nutshell.
                </Body>
                {props.showExplanatoryText ? (
                    <Body isItalic={true} size='small'>
                        This field can’t be removed because all Scheduler forms must include the{' '}
                        {props.label} field
                    </Body>
                ) : undefined}
            </StackLegacy>
        </div>
    );
}
